import { Link } from 'react-router'

export function UnauthorizedPage() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-6 border-2 border-nb-border bg-bg p-10 nb-shadow max-w-sm w-full mx-4">
        <div className="flex items-center justify-center w-16 h-16 border-2 border-nb-border bg-main nb-shadow rounded-base">
          <span className="text-2xl font-heading text-main-foreground">403</span>
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="font-heading text-xl">Access Denied</h1>
          <p className="text-sm text-muted-foreground">
            You do not have permission to view this page.
            Only Admins and Teachers can access the admin panel.
          </p>
        </div>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-5 py-2 border-2 border-nb-border bg-main text-main-foreground font-base text-sm nb-shadow hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all rounded-base"
        >
          Back to Chatbot
        </Link>
      </div>
    </div>
  )
}
